import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up-light.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down-light.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-4994eb09")

_pushScopeId("data-v-4994eb09")
const _hoisted_1 = { class: "relative flex flex-col" }
const _hoisted_2 = { class: "text-12px xxl:text-14px text-gray-lp-300 font-semibold" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "text-20px flex items-center cursor-pointer ml-2 text-red-lp-100 font-semibold" }
const _hoisted_5 = { style: {"margin-left":"-14px","margin-right":"-14px","width":"300px"} }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "border-b border-gray-lp-400 px-4 py-2" }, [
  /*#__PURE__*/_createVNode("div", { class: "inline-flex justify-between" }, [
    /*#__PURE__*/_createVNode("div", { class: "font-semibold text-16px" }, "Detail berat barang")
  ])
], -1)
const _hoisted_7 = { class: "flex flex-col pb-2 gap-1 p-4 text-14px xxl:text-14px text-black-lp-100" }
const _hoisted_8 = { class: "flex flex-row gap-1" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "flex flex-grow" }, " Total barang ", -1)
const _hoisted_10 = { class: "text-1px text-right" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "flex flex-grow" }, " Total berat kotor ", -1)
const _hoisted_12 = { class: "text-1px text-right" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "flex flex-grow" }, " Total berat dimensi ", -1)
const _hoisted_14 = { class: "text-1px text-right" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "px-4" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_16 = { class: "flex flex-row pb-2" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "flex flex-grow text-black-lp-100 text-14px xxl:text-14px float-left pl-4 pt-2" }, " Berat dikenakan biaya ", -1)
const _hoisted_18 = { class: "text-black-lp-100 text-1px xxl:text-14px pr-4 float-right text-right pt-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('bookingShipment.column.chargeableWeight')), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.chargeableWeight) + " Kg ", 1),
      _withDirectives(_createVNode("div", {
        class: "flex items-center ml-2",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleTooltip($event)))
      }, [
        _createVNode("img", {
          alt: "up",
          class: `cursor-pointer ${_ctx.isShow ? '' : 'hidden'}`,
          src: _imports_0
        }, null, 2),
        _createVNode("img", {
          alt: "down",
          class: `cursor-pointer ${_ctx.isShow ? 'hidden' : ''}`,
          src: _imports_1
        }, null, 2)
      ], 512), [
        [_directive_click_outside, () => _ctx.onCloseAnywhere(false)]
      ])
    ]),
    _createVNode(_component_OverlayPanel, {
      ref: "opTooltip",
      appendTo: "body",
      class: "w-auto",
      unstyled: true
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode("div", _hoisted_10, _toDisplayString(_ctx.totalItem), 1)
            ]),
            _createVNode("div", {
              class: `flex flex-row gap-1 ${_ctx.isGrossWeight && !_ctx.isCampaign ? 'text-black-lp-100' : 'text-gray-lp-600'}`
            }, [
              _hoisted_11,
              _createVNode("div", _hoisted_12, _toDisplayString(_ctx.totalGrossWeight) + " kg ", 1)
            ], 2),
            _createVNode("div", {
              class: `flex flex-row gap-1 text-gray-lp-600 ${
                  _ctx.isVolumeWeight && !_ctx.isCampaign
                        ? 'text-black-lp-100'
                        : 'text-gray-lp-600'
                    }`
            }, [
              _hoisted_13,
              _createVNode("div", _hoisted_14, _toDisplayString(_ctx.totalDimensionWeight) + " kg ", 1)
            ], 2)
          ]),
          _hoisted_15,
          _createVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode("div", _hoisted_18, _toDisplayString(_ctx.chargeableWeight) + " kg ", 1)
          ])
        ])
      ]),
      _: 1
    }, 512)
  ], 512)), [
    [_directive_click_outside, () => _ctx.onCloseAnywhere(false)]
  ])
})